// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quality-summary[data-v-b395270c] {
  color: #333;
  font-family: 'AvenirNextLTW01-Regular', Arial, serif;
  font-size: 14px;
}
.quality-summary .list-label-value[data-v-b395270c] {
  margin-top: 20px;
}
.quality-summary .adjust-down[data-v-b395270c] {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/QualitySummary.vue","webpack://./QualitySummary.vue"],"names":[],"mappings":"AACA;EACC,WAAA;EACA,oDAAA;EACA,eAAA;ACAD;ADHA;EAKE,gBAAA;ACCF;ADNA;EAQE,gBAAA;ACCF","sourcesContent":["\n.quality-summary {\n\tcolor: #333;\n\tfont-family: 'AvenirNextLTW01-Regular', Arial, serif;\n\tfont-size: 14px;\n\t.list-label-value {\n\t\tmargin-top: 20px;\n\t}\n\t.adjust-down {\n\t\tmargin-top: 10px;\n\t}\n}\n",".quality-summary {\n  color: #333;\n  font-family: 'AvenirNextLTW01-Regular', Arial, serif;\n  font-size: 14px;\n}\n.quality-summary .list-label-value {\n  margin-top: 20px;\n}\n.quality-summary .adjust-down {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
